import { Component, OnInit, ElementRef, AfterViewInit } from '@angular/core';

import 'rxjs/add/observable/forkJoin';
import { Observable } from 'rxjs/Observable';

import { TransacaoService } from './../../../../shared/services/transacao/transacao.service';
import { LocalStorageService } from '../../../../shared/services/local-storage/local-storage.service';

import { environment } from './../../../../../environments/environment';

import * as moment from 'moment';
import * as Taggle from 'taggle';
import { LoginService } from 'app/shared/services/auth/login/login.service';

declare var $: any;

@Component({
  selector: 'app-transacoes',
  templateUrl: './transacoes.component.html',
  styleUrls: ['./transacoes.component.scss']
})
export class TransacoesComponent implements OnInit, AfterViewInit {
  public isPagueLaAdmin = false;
  public table: any = null;
  public maxTags = 4;
  public tagglejs: any = null;
  public transaction: any = null;

  public transactions: any = [];
  public transactionsBkp: any = [];

  public error = false;
  public loaded = false;
  public success = false;
  public refunding = false;
  public errorRefund = false;

  public inputSearch = '';
  public boxHidden = true;
  public showModal = false;
  public showModalEstorno = false;

  public finalDateFilter: Date = null;
  public transactionIds: string[] = [];
  public initialDateFilter: Date = null;

  public successReturnCodesProduction: string[] = ['0', '00', '000', '0000'];
  public successReturnCodesSandbox: string[] = ['4', '6', '0', '00', '000', '0000'];

  public brands: any = [
    { name: 'JCB', className: 'jcb', actived: false },
    { name: 'Elo', className: 'elo', actived: false },
    { name: 'Visa', className: 'visa', actived: false },
    { name: 'Aura', className: 'aura', actived: false },
    { name: 'Master', className: 'master', actived: false },
    { name: 'Diners', className: 'diners', actived: false },
    { name: 'Discover', className: 'discover', actived: false },
    { name: 'Amex', className: 'american-express', actived: false }
  ];

  public status: any = [
    { name: 'Aprovado', className: 'status-aprovado', actived: false },
    { name: 'Reprovado', className: 'status-reprovado', actived: false },
    { name: 'Estornado', className: 'status-estornado', actived: false }
  ];

  constructor(
    private elRef: ElementRef,
    private localStorage: LocalStorageService,
    private transacaoService: TransacaoService,
    private loginService: LoginService
  ) { }

  ngOnInit() {
    this.clickListener();
    this.clickOutListener();


    moment.locale('pt-br');

    this.isPagueLaAdmin = this.loginService.isAdmin();
  }

  ngAfterViewInit() {
    const self = this;
    this.tagglejs = new Taggle('input-tag', {
      onTagAdd: function() {
        self.filter();
      },
      onTagRemove: function(e, tag) {
        self.markTagAsInactive(tag);
        self.filter();
      },
      placeholder: '',
      maxTags: this.maxTags,
      preserveCase: true,
    });
  }

  clickListener() {
    const caixaPesquisa = this.elRef.nativeElement.querySelector('.caixa-pesquisa');
    if (caixaPesquisa) {
      const self = this;
      this.elRef.nativeElement.querySelector('.caixa-pesquisa').addEventListener('click', function(e) {
        self.elRef.nativeElement.querySelector('.input-searchbox').focus();
      });
    }
  }

  changeTag(e, value) {
    if (this.tagglejs.tag.values.length === this.maxTags) {
      return;
    }

    if (e.target.checked) {
      this.addTag(value);
      this.markTagAsActive(value);

      e.target.checked = false;
    }
  }

  addTag(value) {
    this.tagglejs.add(value);
  }

  markTagAsActive(value) {
    this.brands.forEach((brand) => {
      if (brand.name === value) {
        brand.actived = true;
      }
    });

    this.status.forEach((s) => {
      if (s.name === value) {
        s.actived = true;
      }
    });
  }

  markTagAsInactive(value) {
    this.brands.forEach((brand) => {
      if (brand.name === value) {
        brand.actived = false;
      }
    });

    this.status.forEach((s) => {
      if (s.name === value) {
        s.actived = false;
      }
    });
  }

  getTransacoes() {
    this.transactions = [];

    const user = this.localStorage.get('login');

    if (!user || !user.PersonId) {
      return;
    }

    let initialDate: any = moment(this.initialDateFilter).format('DD/MM/YYYY').replace(/\//g, '-');

    initialDate = initialDate.split('-');
    initialDate = new Date(initialDate[2], initialDate[1] - 2, initialDate[0]);

    initialDate = moment(initialDate).format('YYYY-MM-DD');

    let finalDate: any = moment(this.finalDateFilter).format('DD/MM/YYYY').replace(/\//g, '-');

    finalDate = finalDate.split('-');
    finalDate = new Date(finalDate[2], finalDate[1] - 2, finalDate[0]);

    finalDate = moment(finalDate).format('YYYY-MM-DD');

    this.transacaoService.obterTransacoesPorContaId(user.PersonId, initialDate, finalDate).subscribe((data: any) => {
      data.Transacoes.sort(function(a, b) {
        if (a.TransacaoCd < b.TransacaoCd) { return -1; }
        if (a.TransacaoCd > b.TransacaoCd) { return 1; }
        return 0;
      });

      data.Transacoes.reverse();
      data.Transacoes.forEach((row) => {
        row.Valor = row.Valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      });

      this.transactions = data.Transacoes;

      this.transactionsBkp = this.transactions;

      this.filter();
    }, (err) => {

      this.error = true;
      console.error(err);
    });
  }

  hasStatusInTransactions(status) {
    let hasStatus = false;

    this.transactionsBkp.forEach((transaction) => {
      if (status === 'Estornado' && transaction.Situacao === 'Estornado') {
        hasStatus = true;
      } else {
        const returnCodes = environment.production ? this.successReturnCodesProduction : this.successReturnCodesSandbox;

        if (
          status === 'Aprovado' &&
            (
              transaction.CodigoRetorno === returnCodes[0] ||
              transaction.CodigoRetorno === returnCodes[1] ||
              transaction.CodigoRetorno === returnCodes[2] ||
              transaction.CodigoRetorno === returnCodes[3] ||
              transaction.CodigoRetorno === returnCodes[4] ||
              transaction.CodigoRetorno === returnCodes[5]
            )
          ) {
          hasStatus = true;
        } else if (
          status === 'Reprovado' &&
          transaction.CodigoRetorno !== returnCodes[0] &&
          transaction.CodigoRetorno !== returnCodes[1] &&
          transaction.CodigoRetorno !== returnCodes[2] &&
          transaction.CodigoRetorno !== returnCodes[3] &&
          transaction.CodigoRetorno !== returnCodes[4] &&
          transaction.CodigoRetorno !== returnCodes[5]
        ) {
          hasStatus = true;
        }
      }
    });

    return hasStatus;
  }

  hasBandeiraInTransactions(bandeira) {
    let hasBandeira = false;

    this.transactionsBkp.forEach((transaction) => {
      if (transaction.BandeiraCartao === bandeira) {
        hasBandeira = true;
      }
    });

    return hasBandeira;
  }

  toggleBox() {
    this.boxHidden = !this.boxHidden;
  }

  showData() {
    $.fn.dataTable.moment('DD/MM/YYYY');

    const self = this;

    if ( !this.isPagueLaAdmin ) {
      this.table = $('#master-detail-table').DataTable({
        order: [[3, 'desc']],
        scrollX: true,
        destroy: true,
        paging: true,
        pagingType: 'numbers',
        lengthChange: false,
        searching: false,
        processing: false,
        info: true,
        data: self.transactions,
        language: {
          emptyTable: ' ',
          info: '_START_ - _END_ de _MAX_',
        },
        initComplete: function() {
          self.selectsListenner();

          self.loaded = true;

          if (self.transactions && self.transactions.length === 0) {
            $('#master-detail-table_info').html('0 - 0 de 0');
          }
        },
        columns: [
          { title: 'ID', data: 'TransacaoCd' },
          {
            title: 'Nome do Cliente',
            data: null,
            render: function(data, type, row) {
              if (row && row.NomeCliente && typeof row.NomeCliente === 'string') {
                return row.NomeCliente;
              }
              if (row && row.NomeComprador) {
                return row.NomeComprador;
              }
              return '';
            }
          },
          {
            title: 'Nome do Comprador',
            data: null,
            render: function(data, type, row) {
              if (row && row.NomeComprador) {
                return row.NomeComprador;
              }
              if (row && row.NomeCliente && typeof row.NomeCliente === 'string') {
                return row.NomeCliente;
              }
              return '';
            }
          },
          {
            title: 'Data',
            data: null,
            render: function(data, type, row) {
              if (row.DataRecebimento) {
                return moment(row.DataRecebimento).format('DD/MM/YYYY');
              }
              return moment(row.DataCadastro).format('DD/MM/YYYY');
            }
          },
          { title: 'Forma de Pagamento',
            data: null,
            width: '150px',
            render: function(data, type, row, meta) {
              const bandeiraCartao = self.getBandeiraClass(row.BandeiraCartao);
              const lastDigits = self.getLastDigits(row.NumeroCartao);
              return '<div style="width: 150px">' +
                '<div class="bandeira-cartao ' + bandeiraCartao + '"></div>' +
                '<span class="numero-cartao">' + lastDigits + '</span>' +
                '</div>';
            }
          },
          { title: 'Valor', data: 'Valor', },
          {
            title: 'Status',
            data: 'Status',
            class: 'status',
            render: function(data, type, row, meta) {
              const statusAprovado = '<span class="status-aprovado">Aprovado</span>';
              const statusReprovado = '<span class="status-reprovado">Reprovado</span>';
              const statusEstornado = '<span class="status-estornado">Estornado</span>';

              if (row.Situacao && row.Situacao === 'Estornado') {
                return statusEstornado;
              } else {
                const returnCodes = environment.production ? self.successReturnCodesProduction : self.successReturnCodesSandbox;

                if (
                  row.CodigoRetorno === returnCodes[0] ||
                  row.CodigoRetorno === returnCodes[1] ||
                  row.CodigoRetorno === returnCodes[2] ||
                  row.CodigoRetorno === returnCodes[3] ||
                  row.CodigoRetorno === returnCodes[4] ||
                  row.CodigoRetorno === returnCodes[5]
                ) {
                  return statusAprovado;
                } else {
                  return statusReprovado;
                }
              }
            }
          },
        ]
      });
    }

    if ( this.isPagueLaAdmin ) {
      this.table = $('#master-detail-table').DataTable({
        order: [[4, 'desc']],
        scrollX: true,
        destroy: true,
        paging: true,
        pagingType: 'numbers',
        lengthChange: false,
        searching: false,
        processing: false,
        info: true,
        data: self.transactions,
        language: {
          emptyTable: ' ',
          info: '_START_ - _END_ de _MAX_',
        },
        initComplete: function() {
          self.selectsListenner();

          self.loaded = true;

          if (self.transactions && self.transactions.length === 0) {
            $('#master-detail-table_info').html('0 - 0 de 0');
          }
        },
        columns: [
          {
            title:
              '<div>' +
              '<input id="selectAll" type="checkbox" class="styled-checkbox">' +
              '<label for="selectAll">' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">' +
              '<title></title>' +
              '<polyline ' +
              'points="4 8 7 11 12 6" ' +
              'fill="none" stroke="#fff" ' +
              'stroke-linecap="round" ' +
              'stroke-linejoin="round" ' +
              'stroke-width="2"/>' +
              '</svg>' +
              '</label>' +
              '</div>',
            data: null,
            render: function(data, type, row, meta) {
              return '<div>' +
                '<input id="' + row.TransacaoId + '" type="checkbox" class="styled-checkbox">' +
                '<label for="' + row.TransacaoId + '">' +
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">' +
                '<title></title>' +
                '<polyline ' +
                'points="4 8 7 11 12 6" ' +
                'fill="none" ' +
                'stroke="#fff" ' +
                'stroke-linecap="round" ' +
                'stroke-linejoin="round" ' +
                'stroke-width="2"/>' +
                '</svg>' +
                '</label>' +
                '</div>';
            }
          },
          { title: 'ID', data: 'TransacaoCd' },
          {
            title: 'Nome do Cliente',
            data: null,
            render: function(data, type, row) {
              if (row && row.NomeCliente && typeof row.NomeCliente === 'string') {
                return row.NomeCliente;
              }
              if (row && row.NomeComprador) {
                return row.NomeComprador;
              }
              return '';
            }
          },
          {
            title: 'Nome do Comprador',
            data: null,
            render: function(data, type, row) {
              if (row && row.NomeComprador) {
                return row.NomeComprador;
              }
              if (row && row.NomeCliente && typeof row.NomeCliente === 'string') {
                return row.NomeCliente;
              }
              return '';
            }
          },
          {
            title: 'Data',
            data: null,
            render: function(data, type, row) {
              if (row.DataRecebimento) {
                return moment(row.DataRecebimento).format('DD/MM/YYYY');
              }
              return moment(row.DataCadastro).format('DD/MM/YYYY');
            }
          },
          { title: 'Forma de Pagamento',
            data: null,
            width: '150px',
            render: function(data, type, row, meta) {
              const bandeiraCartao = self.getBandeiraClass(row.BandeiraCartao);
              const lastDigits = self.getLastDigits(row.NumeroCartao);
              return '<div style="width: 150px">' +
                '<div class="bandeira-cartao ' + bandeiraCartao + '"></div>' +
                '<span class="numero-cartao">' + lastDigits + '</span>' +
                '</div>';
            }
          },
          { title: 'Valor', data: 'Valor', },
          {
            title: 'Status',
            data: 'Status',
            class: 'status',
            render: function(data, type, row, meta) {
              const statusAprovado = '<span class="status-aprovado">Aprovado</span>';
              const statusReprovado = '<span class="status-reprovado">Reprovado</span>';
              const statusEstornado = '<span class="status-estornado">Estornado</span>';

              if (row.Situacao && row.Situacao === 'Estornado') {
                return statusEstornado;
              } else {
                const returnCodes = environment.production ? self.successReturnCodesProduction : self.successReturnCodesSandbox;

                if (
                  row.CodigoRetorno === returnCodes[0] ||
                  row.CodigoRetorno === returnCodes[1] ||
                  row.CodigoRetorno === returnCodes[2] ||
                  row.CodigoRetorno === returnCodes[3] ||
                  row.CodigoRetorno === returnCodes[4] ||
                  row.CodigoRetorno === returnCodes[5]
                ) {
                  return statusAprovado;
                } else {
                  return statusReprovado;
                }
              }
            }
          },
        ]
      });
    }

    this.rowClickListener();

    $('#master-detail-table').on('page.dt', function() {
      self.rowClickListener();
      self.selectsListenner();
    });
  }

  getBandeiraClass(bandeira) {
    switch (bandeira) {
      case 'Elo':
        return 'elo';
      case 'Visa':
        return 'visa';
      case 'Master':
        return 'master';
      case 'Amex':
        return 'amex';
      case 'Diners':
        return 'diners';
      case 'Discover':
        return 'discover';
      case 'Aura':
        return 'aura';
      case 'JCB':
        return 'jcb';
      default:
        return 'default';
    }
  }

  selectAll(e) {
    this.transactionIds = [];

    const inputs = this.elRef.nativeElement.querySelectorAll('tbody input');
    if (e.target.checked) {
      for (let i = 0; i < inputs.length; i++) {
        this.transactionIds.push(inputs[i].id);
        inputs[i].checked = true;
        inputs[i].parentNode.parentNode.parentNode.style.backgroundColor = '#f7f7f7';
      }
    } else {
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].checked = false;
        inputs[i].parentNode.parentNode.parentNode.style.backgroundColor = '#f7f7f7';
      }
    }
  }

  selectRow(e: any) {
    const transacao = this.transactions.find(t => t.TransacaoId === e.target.id);
    const returnCodes = environment.production ? this.successReturnCodesProduction : this.successReturnCodesSandbox;

    if (
      transacao &&
      e.target.checked &&
      transacao.Situacao &&
      transacao.Situacao !== 'Estornado' &&
      (
        transacao.CodigoRetorno === returnCodes[0] ||
        transacao.CodigoRetorno === returnCodes[1] ||
        transacao.CodigoRetorno === returnCodes[2] ||
        transacao.CodigoRetorno === returnCodes[3] ||
        transacao.CodigoRetorno === returnCodes[4] ||
        transacao.CodigoRetorno === returnCodes[5]
      )
    ) {
      const transactionId = this.transactionIds.find((t) => t === e.target.id);
      if (!transactionId) {
        this.transactionIds.push(e.target.id);
        e.target.parentNode.parentNode.parentNode.classList.add('row-selected');
      }

    } else {
      this.transactionIds = this.transactionIds.filter(item => item !== e.target.id );
      e.target.parentNode.parentNode.parentNode.classList.remove('row-selected');
    }
  }

  getLastDigits(numeroCartao) {
    if (!numeroCartao) { return ''; }
    return 'final ' + numeroCartao.substring(numeroCartao.length - 4, numeroCartao.length);
  }

  setFilterDate(e) {
    this.initialDateFilter = new Date(e.firstSelection.year, e.firstSelection.month, e.firstSelection.day);
    this.finalDateFilter = new Date(e.lastSelection.year, e.lastSelection.month, e.lastSelection.day);

    this.getTransacoes();
  }

  filter() {
    this.filterByNameAndCardNumber(false);
    this.filterByBandeira(true);
    this.filterByStatus(true);

    this.transactions.sort(function(a, b) {
      if (!moment(a.DataRecebimento).isAfter(b.DataRecebimento)) { return 1; }
      if (moment(a.DataRecebimento).isAfter(b.DataRecebimento)) { return -1; }
      return 0;
    });

    if (this.table) {
      this.table.destroy();
      this.showData();
    } else {
      this.showData();
    }
  }

  filterByNameAndCardNumber(init) {
    this.transactions = init ? this.transactions : this.transactionsBkp;
    let transacoesAux = [];

    if (this.inputSearch.length > 0) {
      this.transactions.forEach((transaction) => {
        if (transaction.NomeCliente && transaction.NomeCliente.toLowerCase().includes(this.inputSearch.toLowerCase())) {
          transacoesAux.push(transaction);
        }

        if (transaction.NomeComprador && transaction.NomeComprador.toLowerCase().includes(this.inputSearch.toLowerCase())) {
          if (!transacoesAux.includes(transaction)) {
            transacoesAux.push(transaction);
          }
        }

        if (transaction.NumeroCartao && transaction.NumeroCartao.toLowerCase().includes(this.inputSearch.toLowerCase())) {
          transacoesAux.push(transaction);
        }
      });
    } else {
      transacoesAux = this.transactions;
    }

    this.transactions = transacoesAux;
  }

  filterByBandeira(init) {
    this.transactions = init ? this.transactions : this.transactionsBkp;
    const transacoesAux = this.tagglejs.tag.values.length === 0 ? this.transactions : [];

    let isBandeira = false;

    this.tagglejs.tag.values.forEach((tag) => {
      this.brands.forEach((bandeira) => {
        if (bandeira.name === tag) {
          isBandeira = true;
        }
      });

      this.transactions.forEach((transaction) => {
        if (isBandeira && transaction.BandeiraCartao && transaction.BandeiraCartao.toLowerCase().includes(tag.toLowerCase())) {
          transacoesAux.push(transaction);
        }
      });
    });

    if (isBandeira) {
      this.transactions = transacoesAux;
    }
  }

  filterByStatus(init) {
    this.transactions = init ? this.transactions : this.transactionsBkp;
    const transacoesAux = this.tagglejs.tag.values.length === 0 ? this.transactions : [];

    let isStatus = false;

    this.tagglejs.tag.values.forEach((tag) => {
      this.status.forEach((status) => {
        if (status.name === tag) {
          isStatus = true;
        }
      });

      this.transactions.forEach((transaction) => {
        if (isStatus && tag === 'Estornado' && transaction.Situacao === 'Estornado') {
          transacoesAux.push(transaction);
        } else {
          const returnCodes = environment.production ? this.successReturnCodesProduction : this.successReturnCodesSandbox;

          if (
            isStatus &&
            tag === 'Aprovado' &&
            (
              transaction.CodigoRetorno === returnCodes[0] ||
              transaction.CodigoRetorno === returnCodes[1] ||
              transaction.CodigoRetorno === returnCodes[2] ||
              transaction.CodigoRetorno === returnCodes[3] ||
              transaction.CodigoRetorno === returnCodes[4] ||
              transaction.CodigoRetorno === returnCodes[5]
            )
          ) {
            transacoesAux.push(transaction);
          }

          if (
            isStatus &&
            tag === 'Reprovado' &&
            transaction.CodigoRetorno !== returnCodes[0] &&
            transaction.CodigoRetorno !== returnCodes[1] &&
            transaction.CodigoRetorno !== returnCodes[2] &&
            transaction.CodigoRetorno !== returnCodes[3] &&
            transaction.CodigoRetorno !== returnCodes[4] &&
            transaction.CodigoRetorno !== returnCodes[5]
          ) {
            transacoesAux.push(transaction);
          }
        }
      });
    });

    if (isStatus) {
      this.transactions = transacoesAux;
    }
  }

  selectsListenner() {
    if ( this.isPagueLaAdmin ) {
      const self = this;
      document.querySelector('#selectAll').addEventListener('click', function(e) {
        self.selectAll(e);
      });

      setTimeout(() => {
        const inputs: any = document.querySelectorAll('.styled-checkbox');
        inputs.forEach((input) => {
          input.addEventListener('click', function(e: any) {
            if (e.target.id !== 'selectAll') {
              self.selectRow(e);
            }
          });
        });
      }, 500);
    }
  }

  buttomRefund() {
    this.success = false;
    this.errorRefund = false;
    this.refunding = false;
    this.showModalEstorno = true;
  }

  refund() {
    this.refunding = true;

    const requestArr = [];
    this.transactionIds.forEach((transactionId) => {
      const transaction = this.transactions.filter(item => item.TransacaoId === transactionId)[0];

      if (transaction && (!transaction.Situacao || (transaction.Situacao && transaction.Situacao !== 'Estornado'))) {
        const transacaoRequest = this.transacaoService.estornar(transaction.TransacaoId);
        requestArr.push(transacaoRequest);
      }
    });

    Observable
        .forkJoin(requestArr)
        .subscribe((data) => {
          this.transactions.forEach((transaction) => {
            if (!transaction.Situacao) {
              this.errorRefund = true;
            }

            data.forEach((t: any) => {
              if (t.TransacaoId === transaction.TransacaoId) {
                transaction.Situacao = t.Situacao;
              }
            });
          });

          this.refunding = false;
          this.success = true;

          if (this.table) {
            this.table.destroy();
            this.showData();
          }
        }, (err) => {
          this.errorRefund = true;
          console.error(err);
        });
  }

  clickOutListener() {
    const self = this;
    document.addEventListener('click', function(e: any) {
      if (e.target.closest('.box-filter')) { return; }

      if (!self.boxHidden && !e.target.closest('.filter-icon')) {
        self.toggleBox();
      }
    });
  }

  rowClickListener() {
    const self = this;
    $('#master-detail-table tbody').on('click', 'tr', function(e) {
      if (e.target.className !== 'styled-checkbox' && e.target.nodeName !== 'svg' && e.target.localName !== 'polyline') {
        const data = self.table.row(this).data();
        self.transaction = data;
        self.showModal = true;
      }
    });
  }

  eventClose() {
    this.showModal = false;
  }

  eventCloseEstorno() {
    this.showModalEstorno = false;
  }

  isTodayDate(date) {
    return moment(date).format('DD/MM/YYYY') === moment().format('DD/MM/YYYY') ? true : false;
  }

  formatDate(date) {
    return moment(date).format('DD/MM/YYYY');
  }

  formatDateAndHour(date) {
    const dateFormated = moment(date).format('DD/MM/YYYY');
    const timeFormated = moment(date).format('HH:mm:ss');

    return dateFormated + ' às ' + timeFormated;
  }

  getTransactionStatus(transaction) {
    if (transaction && transaction.Situacao === 'Estornado') {
      return { title: 'Transação Estornada', className: 'transacao-estornada' };
    } else {
      const returnCodes = environment.production ? this.successReturnCodesProduction : this.successReturnCodesSandbox;

      if (
        transaction &&
        transaction.CodigoRetorno === returnCodes[0] ||
        transaction.CodigoRetorno === returnCodes[1] ||
        transaction.CodigoRetorno === returnCodes[2] ||
        transaction.CodigoRetorno === returnCodes[3] ||
        transaction.CodigoRetorno === returnCodes[4] ||
        transaction.CodigoRetorno === returnCodes[5]
      ) {
        return { title: 'Transação Aprovada', className: 'transacao-aprovada' };
      } else {
        return { title: 'Transação Reprovada', className: 'transacao-reprovada' };
      }
    }
  }

  hasError(transaction) {
    const returnCodes = environment.production ? this.successReturnCodesProduction : this.successReturnCodesSandbox;

    if (
      transaction &&
      transaction.CodigoRetorno !== returnCodes[0] &&
      transaction.CodigoRetorno !== returnCodes[1] &&
      transaction.CodigoRetorno !== returnCodes[2] &&
      transaction.CodigoRetorno !== returnCodes[3] &&
      transaction.CodigoRetorno !== returnCodes[4] &&
      transaction.CodigoRetorno !== returnCodes[5]
    ) {
      return true;
    }

    return false;
  }

  toNumber(string: string): number {
    return Number(string);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/transacoes/transacoes.component.ts